import { render, staticRenderFns } from "./ModalBranch.vue?vue&type=template&id=5a166268&"
import script from "./ModalBranch.vue?vue&type=script&lang=js&"
export * from "./ModalBranch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports